import { Fade, Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import { Gateway } from '../../types/gateway'
import GatewayRowMobile from './GatewayRowMobile'
import GatewayRowMobileSkeleton from './GatewayRowMobile.skeleton'
import useStyles from './styles/GatewaysTableMobile.styles'

interface GatewayListMobileProps {
  data: Gateway[]
  loading: boolean
  hasAccessToViewGateway: boolean | undefined
}

const GatewayListMobile: React.FC<GatewayListMobileProps> = ({
  data,
  loading,
  hasAccessToViewGateway
}) => {
  const classes = useStyles()
  return (
    <div>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Entity Name')}</Typography>
        </div>
      </div>
      {loading
        ? Array(6)
            .fill('')
            .map((item, index) => (
              <GatewayRowMobileSkeleton
                key={`accommodation-skeleton${item}${index.toString()}`}
              />
            ))
        : data.map((singleGateway: Gateway) => (
            <Fade in timeout={600} key={singleGateway.basicDetails.gatewayId}>
              <div>
                <GatewayRowMobile
                  hasAccessToViewGateway={hasAccessToViewGateway}
                  data={singleGateway}
                />
              </div>
            </Fade>
          ))}
    </div>
  )
}
export default GatewayListMobile
